<template>
  <div class="md-layout md-gutter-sm">
    <!-- Header -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content class="order-header">
          <div class="order-info">
            <h6>Order Number: <strong>{{ orderData.orderNumber }}</strong></h6>
            <h6>Order Date: <strong>{{ HumanReadableDateFormat(orderData.created_at) }}</strong></h6>
          </div>

          <div class="button-group">
            <button 
              type="button"
              class="btn btn-secondary btn-sm"
              @click="openQrModal"
            >
              View QR Code
            </button>

            <button 
              type="button"
              class="btn btn-primary btn-sm"
              @click="$router.push({
                path: '/kid/review-request',
                query: { email: orderData.email, orderNumber: orderData.orderNumber }
              })"
            >
              Request Review
            </button>
          </div>
        </md-card-content>

      </md-card>
    </div>

    <md-dialog :md-active.sync="qrModal">
      <md-dialog-title>Default Enrollment QR Code</md-dialog-title>

      <md-dialog-content>
        <div class="qr-modal-container">
          <img src="/img/WingioDefaultQrCode.png" class="qr-large" />
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="qrModal = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>


    <!-- Tracking Information Section -->
    <div class="md-layout-item md-size-100" v-if="orderData.trackingNumber">
      <md-card>
        <md-card-header>
          <div class="title"><b>Tracking Information</b> &nbsp; 
            <a href="javascript:void(0)" style="color:blue !important" @click="trackingDetailModal = true"><i class="fas fa-pen"></i></a>
          </div>
        </md-card-header>
        <md-card-content>
          <ul>
          <li v-if="orderData.trackingNumber">Tracking Number: <strong>{{ orderData.trackingNumber }}</strong></li>
          <li v-if="orderData.carrierName">Carrier: <strong>{{ orderData.carrierName }}</strong></li>
          <li v-if="orderData.trackingLink">Tracking Link: <a :href="orderData.trackingLink" target="_blank">{{ orderData.trackingLink }}</a></li>
          <li v-if="orderData.expectedDeliveryDate">Expected Delivery Date: <strong>{{ (orderData.expectedDeliveryDate) }}</strong></li>
          </ul>
        </md-card-content>
      </md-card>
    </div>

    <!-- Recipient Info + Status -->
    <div class="md-layout-item md-small-size-100 md-medium-size-40">
        <md-card>
            <md-card-header>
            <div class="title"><b>Recipient Information</b></div>
            </md-card-header>
            <md-card-content class="recipient-info">
            <p>Full Name: <strong>{{ orderData.name }}</strong></p>
            <p>Email: <a href="javascript:void(0)" @click="ByPassUserLogin(orderData.email)">{{ orderData.email  }}</a></p>
            <p>Phone Number: <strong>{{ orderData.phoneNumber }}</strong></p>
            <p v-if="orderData.address">Address:
              <strong>
                {{ formatAddress(orderData.address.address) }}
              </strong>
            </p>
            </md-card-content>
        </md-card>
    </div>


    <div class="md-layout-item md-small-size-100 md-medium-size-60">
      <md-card>
        <md-card-header>
            <md-card-header>
            <div class="title d-flex justify-content-between align-items-center" style="flex-wrap: wrap;">
                <span>Status</span>

                <div class="d-flex align-items-center">
                <span class="text-success font-weight-bold mr-2">{{ orderData.orderStatus }}</span>
                
                <md-menu md-size="medium">
                    <md-button class="md-icon-button" md-menu-trigger>
                        <md-icon>arrow_drop_down</md-icon>
                    </md-button>

                    <md-menu-content>
                      <md-menu-item v-if="orderData.orderStatus == 'Confirmed'" @click="trackingDetailModal = true">Shipped</md-menu-item>
                      <md-menu-item v-if="orderData.orderStatus == 'Shipped'" @click="updateStatus('Out For Delivery')">Out For Delivery</md-menu-item>
                      <md-menu-item v-if="orderData.orderStatus == 'Out For Delivery'" @click="updateStatus('Delivered')">Delivered</md-menu-item>
                    </md-menu-content>
                </md-menu>
                </div>
            </div>
            </md-card-header>
        </md-card-header>
        <md-card-content>
          <div class="stepper">
            <div class="step-item">
                <div class="step active">
                <md-icon>check_circle</md-icon>
                </div>
                <div class="step-label">Confirmed</div>
            </div>

            <div class="step-line" :class="{ active: ['Shipped', 'Out For Delivery', 'Delivered'].includes(orderData.orderStatus) }"></div>
            <div class="step-item">
                <div class="step" :class="{ active: ['Shipped', 'Out For Delivery', 'Delivered'].includes(orderData.orderStatus) }">
                <md-icon>local_shipping</md-icon>
                </div>
                <div class="step-label">Shipped</div>
                <p class="text-center text-muted mt-2" v-if="orderData.orderStatus == 'Shipped'">{{ HumanReadableDateFormat(orderData.orderStatusLastUpdateDate) }}</p>
            </div>

            <div class="step-line" :class="{ active: ['Out For Delivery', 'Delivered'].includes(orderData.orderStatus) }"></div>
            <div class="step-item">
                <div class="step" :class="{ active: ['Out For Delivery', 'Delivered'].includes(orderData.orderStatus) }">
                <md-icon>two_wheeler</md-icon>
                </div>
                <div class="step-label">Out For Delivery</div>
                <p class="text-center text-muted mt-2" v-if="orderData.orderStatus == 'Out For Delivery'">{{ HumanReadableDateFormat(orderData.orderStatusLastUpdateDate) }}</p>
            </div>

            
            <div class="step-line" :class="{ active: orderData.orderStatus === 'Delivered' }"></div>
            <div class="step-item">
                <div class="step" :class="{ active: orderData.orderStatus === 'Delivered' }">
                <md-icon>done_all</md-icon>
                </div>
                <div class="step-label">Delivered</div>
                <p class="text-center text-muted mt-2" v-if="orderData.orderStatus == 'Delivered'">{{ HumanReadableDateFormat(orderData.orderStatusLastUpdateDate) }}</p>
            </div>
        </div>
        </md-card-content>
      </md-card>
    </div>

    <!-- Products Table -->
    <div class="md-layout-item md-size-100">
        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
                <h4 class="title">Products</h4>
            </md-card-header>
            <md-card-content>
            <md-table v-model="products" table-header-color="green">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name">{{ item.prductName }}</md-table-cell>
                <md-table-cell md-label="Qty">
                  <span v-if="item.prductName != 'Wingio Subscription (60 Day Free, Then Billed £4.90 Per Month)'">1</span>
                  <span v-else>{{ item.qty }}</span>
                </md-table-cell>
                <md-table-cell md-label="Unit Price">£{{ item.price }} / {{ item.qty }}</md-table-cell>
                <md-table-cell md-label="Total">£{{ item.totalPrice }}</md-table-cell>
                <md-table-cell md-label="Action">
                      <button v-if="!item.serialNumber && item.prductName != 'Wingio Subscription (60 Day Free, Then Billed £9.99 Per Month)'" type="button" class="btn btn-primary btn-sm" @click="openAllocateDeviceModal(item.subscriptionCode, item._id)">Allocate</button>
                      <span v-if="item.serialNumber">
                        {{ item.serialNumber }}
                        <br><button v-if="item.prductName != 'Wingio Subscription (60 Day Free, Then Billed £9.99 Per Month)'" type="button" class="btn btn-primary btn-sm" @click="openAllocateDeviceModal(item.subscriptionCode, item._id, item.serialNumber)">Re-Allocate</button>
                      </span>
                </md-table-cell>
                </md-table-row>
            </md-table>
            </md-card-content>
        </md-card>
    </div>

    <!-- Payment Info + Notes -->
    <div class="md-layout-item md-small-size-100 md-medium-size-50">
      <md-card>
        <md-card-header>
          <div class="title">Payment Information</div>
        </md-card-header>
        <md-card-content>
          <p>Order Total: <span class="float-right">£{{ orderData.orderTotal }}</span></p>
          <p>Discount: <span class="float-right">£{{ orderData.discountAmount }}</span></p>
          <p>Shipping Fee: <span class="float-right">£0</span></p>
          <p>Tax: <span class="float-right">£{{ orderData.taxAmount }}</span></p>
          <hr />
          <p class="total">Payable Total: <span class="float-right font-weight-bold">£{{ orderData.payableAmount }}</span></p>
        </md-card-content>
      </md-card>
    </div>

    
     <!-- Email History Section -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header>
          <div class="title">Email History</div>
        </md-card-header>
        <md-card-content>
          <ul v-if="orderData.emailHistory && orderData.emailHistory.length > 0">
            <li v-for="(email, index) in orderData.emailHistory" :key="index" class="email-history-item">
              <div class="email-subject">
                <strong>{{ email.subject }}: </strong>
                <span class="email-time">{{ HumanReadableDateFormat(email.sentAt) }}</span>
              </div>

              <!-- Check if email was sent successfully or failed -->
              <div v-if="email.isEmailSent" class="email-success">
                <span class="icon success">✔️</span> Email sent successfully.
              </div>

              <div v-else class="email-error">
                <span class="icon error">❌</span> <strong>Error:</strong> {{ email.message }}
              </div>
            </li>
            <hr v-if="index < orderData.emailHistory.length - 1">
          </ul>
          <span v-else>No email history record found.</span>
        </md-card-content>
      </md-card>
    </div>

    <!-- Order Audit History Section -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header>
          <div class="title"><b>Order Audit History</b></div>
        </md-card-header>
        <md-card-content>
          <div v-if="orderData.auditHistory && orderData.auditHistory.length === 0">
            <p>No audit history available.</p>
          </div>
          <ul v-if="orderData.auditHistory && orderData.auditHistory.length > 0">
            <li v-for="(entry, index) in orderData.auditHistory" :key="index">
              <strong>{{ entry.action }}</strong> - <span>{{ HumanReadableDateFormat(entry.date) }}</span>
            </li>
          </ul>
        </md-card-content>
      </md-card>
    </div>

    <!-- Order Notes Section -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header>
          <div class="title"><b>Order Notes</b></div>
        </md-card-header>
        <md-card-content>
          <!-- If no notes are present -->
          <div v-if="!orderData.orderNotes || orderData.orderNotes.length === 0">
            <p>No notes available for this order.</p>
          </div>

          <!-- Display existing notes with improved design -->
          <ul v-if="orderData.orderNotes && orderData.orderNotes.length > 0" class="order-notes-list">
            <li v-for="(note, index) in orderData.orderNotes" :key="index" class="order-note-item">
              <div class="note-content">
                <strong>Note {{ index + 1 }}:</strong>
                <p>{{ note }}</p>
              </div>
              <md-button class="md-icon-button delete-button" @click="deleteNote(index)">
                <md-icon>delete</md-icon> <!-- Delete icon -->
              </md-button>
            </li>
          </ul>

          <!-- Add new note button -->
          <md-button class="md-raised md-primary" @click="addNewNote">Add Note</md-button>

          <!-- Dynamic text boxes for adding notes -->
          <div v-for="(note, index) in newNotes" :key="index" class="new-note-box">
            <md-textarea
              v-model="newNotes[index]"
              label="Enter note here..."
              rows="1"
              outlined
              style="width: 100%;"
            ></md-textarea>
            <md-button class="md-icon-button" @click="deleteNewNote(index)">
              <md-icon>delete</md-icon> <!-- Delete icon -->
            </md-button>
          </div>

          <!-- Save button to submit all notes -->
          <md-button class="md-raised md-primary" @click="saveNotes">Save Notes</md-button>

          <!-- Error handling -->
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        </md-card-content>
      </md-card>
    </div>


    <!-- Past Orders Section -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header>
          <div class="title"><b>Past Orders</b></div>
        </md-card-header>
        <md-card-content>
          <div v-if="pastOrders.length == 0">
            <p>No past orders found.</p>
          </div>
          
          <!-- Past Orders Section -->
          <div class="md-layout-item md-size-100">
            <md-card>
              <md-card-content>
                <div v-if="pastOrders.length == 0">
                  <p>No past orders found.</p>
                </div>
                <md-layout v-if="pastOrders.length > 0" class="md-gutter-md">
                  <md-layout-item v-for="orderItem in pastOrders" :key="orderItem.orderNumber" class="md-size-100" :style="{ margin: '1px !important' }">
                    <md-card>
                      <md-card-header>
                        <div class="title">Order #{{ orderItem.orderNumber }}</div>
                      </md-card-header>
                      <md-card-content>
                        <p style="margin-bottom: 1px;"><strong>Date:</strong> {{ (orderItem.created_at) }}</p>
                        <p style="margin-bottom: 1px;"><strong>Status:</strong> <span :class="statusClass(orderItem.orderStatus)">{{ orderItem.orderStatus }}</span></p>
                        <p style="margin-bottom: 1px;"><strong>Total:</strong> £{{ orderItem.orderTotal }}</p>
                        <md-button class="md-primary" @click="$router.push({ path: 'order-detail', query: { id: orderItem._id }})">View Order</md-button>
                      </md-card-content>
                    </md-card>
                  </md-layout-item>
                </md-layout>


              </md-card-content>
            </md-card>
          </div>
        </md-card-content>
      </md-card>
    </div>


  <!--Update Tracking Detail Modal -->
    <template>
        <modal v-if="trackingDetailModal" @close="trackingDetailModal = false">
          <template slot="header">
            <h4 class="modal-title">Update Tracking Detail</h4>
            <md-button
              style="height: 25px" class="md-simple md-just-icon md-round modal-default-button"
              @click="trackingDetailModal = false"><md-icon>clear</md-icon></md-button>
          </template>
          <template slot="body">
          <div class="box-body">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>Tracking Number</label>
                  <md-input type="text" v-model="trackingNumber"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>Tracking Link</label>
                  <md-input type="url" v-model="trackingLink"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>Carrier Name</label>
                  <md-input type="text" v-model="carrierName"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>Expected Delivery Date</label>
                  <md-input type="text" v-model="expectedDeliveryDate"></md-input>
                </md-field>
              </div>
            </div>
          </div>
          </template>
          <template slot="footer">
            <md-button class="md-danger md-simple" @click="trackingDetailModal = false">Close</md-button>
            <md-button class="md-success mt-1" type="submit" :disabled="isDisabled" @click="updateStatus('Shipped')">Save 
              <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
            </md-button>
          </template>
        </modal>
    </template>

    <!--Device Allocate Modal -->
    <template>
        <modal v-if="allocateDeviceModal" @close="allocateDeviceModal = false">
          <template slot="header">
            <h4 class="modal-title">Allocate Device</h4>
            <md-button
              style="height: 25px" class="md-simple md-just-icon md-round modal-default-button"
              @click="allocateDeviceModal = false"><md-icon>clear</md-icon></md-button>
          </template>
          <template slot="body">
          <div class="box-body">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                  <md-field>
                    <label>Serial Number</label>

                    <!-- Search Box for filtering -->
                    <md-input type="text" v-model="searchQuery" placeholder="Search serial number"></md-input>

                    <!-- Select Dropdown with dynamic filtering -->
                    <select id="serialNumberdropdown" v-model="serialNumber" :style=" { width: '100%' }" @change="getProfileDetail()">
                      <option v-for="serialnumber in filteredSerialNumbers" :key="serialnumber" :value="serialnumber">
                        {{ serialnumber }}
                      </option>
                    </select>
                  </md-field>
              </div>
              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>Kid Name</label>
                  <md-input type="text" v-model="kidName" :disabled="kidNameDisabled"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-100" v-if="deviceAllocationList.length > 0">
                <h4><b>Existing Allocation of serial number {{ serialNumber }} </b></h4>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Profile Name</th>
                      <th scope="col">Parent Email</th>
                      <th scope="col">Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="profile in deviceAllocationList" :key="profile._id">
                      <td>{{ profile.profileName }}</td>
                      <td>{{ profile.email }}</td>
                      <td>{{ profile.createdAt }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          </template>
          <template slot="footer">
            <md-button class="md-danger mt-1 mr-2" @click="allocateDeviceModal = false">Close</md-button>
            <md-button class="md-success mt-1" type="submit" :disabled="isDisabled" @click="allocateDevice()">
              Allocate
              <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
            </md-button>
          </template>
        </modal>
    </template>
  </div>
</template>

<script>
import OrdersDataService from "../../services/SuperAdmin/Kids/OrdersDataService";
import { Modal } from "@/components";
import UsersDataService from "../../services/SuperAdmin/UsersDataService";

export default {
  name: "OrderDetail",
  components: {
    Modal,
  },
  data() {
    return {
      id: this.$route.query.id,
      orderData: null,
      products: [],
      trackingDetailModal: false,
      trackingNumber: "",
      trackingLink:"",
      carrierName:"",
      expectedDeliveryDate:"",
      isDisabled: false,
      allocateDeviceModal: false,
      serialNumber:"",
      subscriptionCode: "",
      kidName: "Kid 1",
      kidNameDisabled: false,
      pastOrders: [],
      searchQuery: "",
      availableSerialNumbers: [],
      newNotes: [], // To hold new notes before saving them
      errorMessage: '',
      deviceAllocationList: [],
      qrModal: false,
    };
  },
  computed: {
    // Computed property to filter serial numbers based on the search query
    filteredSerialNumbers() {
      const query = this.searchQuery.toLowerCase();
      return this.availableSerialNumbers.filter((serialNumber) =>
        serialNumber.toLowerCase().includes(query)
      );
    }
  },
  methods: {
    statusClass(status) {
        switch (status) {
            case "Confirmed":
                return "badge badge-success";
            case "Shipped":
                return "badge badge-primary";
            case "Out For Delivery":
                return "badge badge-warning";
            case "Delivered":
                return "badge badge-info";
            default:
                return "";
        }
    },
    orderDetail() {
        let data = { id: this.id};
        OrdersDataService.orderDetail(data)
          .then((response) => {
            this.orderData = response.data.data;
            this.products = this.orderData.orderItemDetail;
            this.availableSerialNumbers = this.orderData.baseDevicesSerialNumber
            this.pastOrders = this.orderData.pastOrders;
            this.trackingNumber = this.orderData.trackingNumber
            this.trackingLink = this.orderData.trackingLink
            this.carrierName = this.orderData.carrierName
            this.expectedDeliveryDate = this.orderData.expectedDeliveryDate
          }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    updateStatus(orderStatus) {
      this.isDisabled = true;
      let data = { id: this.id, orderStatus: orderStatus, trackingNumber: this.trackingNumber, 
      trackingLink: this.trackingLink, carrierName: this.carrierName, expectedDeliveryDate: this.expectedDeliveryDate };
        OrdersDataService.updateStatus(data)
          .then((response) => {
            this.isDisabled = false;
            this.trackingDetailModal = false;
            this.$toast.success(response.data.respones_msg);
            this.orderDetail();
          }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    openAllocateDeviceModal(subscriptionCode, itemId, serialNumber = null) {
      this.subscriptionCode = subscriptionCode;
      this.orderItemId = itemId;
      if (serialNumber) {
        this.availableSerialNumbers.push(serialNumber)
        this.serialNumber = serialNumber
      }
      this.allocateDeviceModal = true
    },
    getProfileDetail() {
      this.kidNameDisabled = true;
      this.isDisabled = true;
      let data = { serialNumber: this.serialNumber, email: this.orderData.email, subscriptionCode: this.subscriptionCode,
      kidName: this.kidName, orderData: this.orderData , orderItemId: this.orderItemId};
        OrdersDataService.getProfileDetail(data)
          .then((response) => {
            this.deviceAllocationList = response.data.deviceAllocationList;
            if (response.data.data) {
              this.kidName = response.data.data
            }
            this.kidNameDisabled = false;
            this.isDisabled = false;
          }).catch((e) => {
            this.kidNameDisabled = false;
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    allocateDevice() {
      if (!this.kidName) {
        return this.$toast.error("Enter kid name."); 
      }
      let data = { serialNumber: this.serialNumber, email: this.orderData.email, subscriptionCode: this.subscriptionCode,
      kidName: this.kidName, orderData: this.orderData , orderItemId: this.orderItemId};
        OrdersDataService.allocateDevice(data)
          .then((response) => {
            this.allocateDeviceModal = false;
            this.$toast.success(response.data.respones_msg);
            this.orderDetail();
            this.serialNumber = "";
            this.allocateDeviceModal = false;
          }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    formatAddress(address) {
      if (!address) return '';

      // Filter out null/undefined/empty fields
      const parts = [
        address.line1,
        address.line2,
        address.city,
        address.state,
        address.country,
        address.postal_code
      ].filter(Boolean);

      return parts.join(', ');
    },
    addNewNote() {
      this.newNotes.push(''); // Add a new empty note
    },
    // Delete a note from the existing notes array
    deleteNote(index) {
      this.orderData.orderNotes.splice(index, 1); // Remove the note from the array
    },

    // Delete a new note (before saving)
    deleteNewNote(index) {
      this.newNotes.splice(index, 1); // Remove the note from the array
    },

    async saveNotes() {
      if (this.newNotes.some(note => !note.trim())) {
        this.errorMessage = 'All notes must be filled!';
        return;
      }
      
      const updatedNotes = [
        ...(this.orderData.orderNotes || []),  // Safely check for null or undefined, default to an empty array
        ...(this.newNotes || [])               // Safely check for null or undefined, default to an empty array
      ];

      let data = { updatedNotes: updatedNotes, id: this.id};
      OrdersDataService.updateNotes(data)
        .then((response) => {
          this.newNotes = []
          this.$toast.success(response.data.respones_msg);
          this.orderDetail();
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });      
    },
    ByPassUserLogin(email) {
        let data = {
            email: email,
        }
        UsersDataService.ByPassUserLogin(data)
        .then((response) => {
            //localStorage.setItem('token', response.data.data.token);
            window.open("https://parent.mywingio.com?token="+response.data.data.token, '_blank');
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    openQrModal() {
      this.qrModal = true;
    }
  },
  beforeMount() {
    this.orderDetail();
  },
};
</script>

<style scoped>
.stepper  {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 10px;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
  text-align: center;
}

.step {
  width: 40px;
  height: 40px;
  background: #e0e0e0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  z-index: 1;
}

.step.active {
  background: #4caf50;
}

.step-line {
  flex: 1;
  height: 4px;
  background-color: #e0e0e0;
  margin: 18px 5px 0; /* aligns line with icon center */
  border-radius: 2px;
  position: relative;
  z-index: 0;
}

.step-line.active {
  background-color: #4caf50;
}

.step-label {
  margin-top: 6px;
  font-size: 12px;
  color: #333;
}


.product-img {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  object-fit: cover;
}

.total {
  font-weight: 600;
}

.md-layout-item {
  margin-bottom: 12px !important; /* Adjust to your preferred spacing */
}

.md-card {
  margin: 0 !important; /* Remove card margin that causes extra spacing */
}

.md-card-header,
.md-card-content {
  padding-top: 8px;
  padding-bottom: 8px;
}

.recipient-info p {
  margin-bottom: 4px; /* reduce space between lines */
}

.email-history-item {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    border-bottom: 1px solid #f0f0f0; /* Add a border to separate items */
}

/* Optional: If you want the hr to only be between items, you can style them directly in the ul */
.email-history-item:not(:last-child) {
    border-bottom: 1px solid #f0f0f0; /* This line creates a separation between items */
}

.new-note-box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

md-textarea {
  width: 100%;  /* Make the textarea take full width */
  margin-right: 10px; /* Add some space between the textarea and delete button */
}

.error-message {
  color: red;
  font-size: 0.9rem;
  margin-top: 10px;
}

.order-notes-list {
  list-style-type: none; /* Remove bullet points */
  padding: 0;
}

.order-note-item {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order-note-item .note-content {
  flex-grow: 1; /* Allow the note text to take up the remaining space */
}

.order-note-item p {
  margin: 5px 0;
  font-size: 1rem;
  color: #333;
}

.delete-button {
  margin-left: 10px; /* Space between note and delete button */
  background-color: #f44336; /* Red background color for delete button */
  color: white;
}

.delete-button md-icon {
  font-size: 20px; /* Increase the size of the delete icon */
}

.md-raised {
  background-color: #3f51b5; /* Blue background color for primary buttons */
  color: white;
}

.md-raised:hover {
  background-color: #303f9f; /* Darker shade on hover */
}

/* Style for error message */
.error-message {
  color: red;
  font-size: 0.9rem;
  margin-top: 10px;
}

/* Style for new note textarea */
.new-note-box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

md-textarea {
  width: 100%;
  margin-right: 10px;
}
.order-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.button-group {
  display: flex;
  align-items: center;
  gap: 10px; /* space between buttons */
}

.qr-modal-container {
  display: flex;
  justify-content: center;
  padding: 10px 0;
}

.qr-large {
  height: 260px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
}

</style>
